"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCannabisStateSyncSchema = exports.APosStateSyncStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosStateSyncStatusSchema = zod_1.z.enum(['pending', 'synced', 'failed', 'retrying']);
exports.APosCannabisStateSyncSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    syncId: id_schema_1.EntityIdSchema,
    system: zod_1.z.enum(['metrc', 'biotrack', 'leaf_data', 'other']),
    syncType: zod_1.z.enum(['package', 'sale', 'transfer', 'disposal', 'adjustment']),
    referenceId: id_schema_1.EntityIdSchema,
    referenceType: zod_1.z.string(),
    payload: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    status: exports.APosStateSyncStatusSchema.default('pending'),
    attempts: zod_1.z.number().int().nonnegative().default(0),
    lastAttemptAt: zod_1.z.number().optional(),
    syncedAt: zod_1.z.number().optional(),
    externalId: zod_1.z.string().optional(),
    errorMessage: zod_1.z.string().max(2000).optional(),
    errorCode: zod_1.z.string().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
//# sourceMappingURL=cannabis-state-sync.schema.js.map